import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import { ThemeProvider } from './components/ThemeProvider';
import Home from './pages/Home';
import SolutionsHub from './pages/SolutionsHub';
import SolutionDetail from './pages/SolutionDetail';
import IndustriesHub from './pages/IndustriesHub';
import IndustryDetail from './pages/IndustryDetail';
import Platform from './pages/Platform';
import AiLab from './pages/AiLab';
import Methodology from './pages/Methodology';
import NationalTransformation from './pages/NationalTransformation';
import About from './pages/About';
import TrustPage from './pages/TrustPage';
import Legal from './pages/Legal';
import Insights from './pages/Insights';
import MeetLisa from './pages/MeetLisa';
import Contact from './pages/Contact';
import Assessment from './pages/Assessment';
import PortalLogin from './pages/PortalLogin';
import PortalDashboard from './pages/PortalDashboard';
import NotFound from './pages/NotFound';

/* Route tree mirrors the old static site's exact URL surface
 * (en/*.html, en/solutions/*.html, en/industries/*.html) one-for-one,
 * just under a /:locale prefix instead of a locale subdirectory — see
 * Layout.tsx for the /en /fr /ar validation + redirect and
 * components/Header.tsx / Footer.tsx for the nav links that point here. */
export default function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/en" replace />} />
        <Route path="/:locale" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="solutions" element={<SolutionsHub />} />
          <Route path="solutions/:slug" element={<SolutionDetail />} />
          <Route path="industries" element={<IndustriesHub />} />
          <Route path="industries/:slug" element={<IndustryDetail />} />
          <Route path="platform" element={<Platform />} />
          <Route path="ai-lab" element={<AiLab />} />
          <Route path="methodology" element={<Methodology />} />
          <Route path="national-transformation" element={<NationalTransformation />} />
          <Route path="about" element={<About />} />
          <Route path="security" element={<TrustPage category="security" title="Security" />} />
          <Route path="sovereignty" element={<TrustPage category="sovereignty" title="Sovereignty" />} />
          <Route path="team" element={<TrustPage category="team" title="Team" />} />
          <Route path="legal" element={<Legal />} />
          <Route path="insights" element={<Insights />} />
          <Route path="meet-lisa" element={<MeetLisa />} />
          <Route path="contact" element={<Contact />} />
          <Route path="assessment" element={<Assessment />} />
          <Route path="portal-login" element={<PortalLogin />} />
          <Route path="portal" element={<PortalDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<Navigate to="/en" replace />} />
      </Routes>
    </ThemeProvider>
  );
}
